// Lightweight opt-in browser notification + sound helpers for Support Chat (Phase 3).
// In-app notifications always work regardless of these; these are the optional extras.

export function browserPermission() {
  if (typeof Notification === "undefined") return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function requestBrowserPermission() {
  if (typeof Notification === "undefined") return "unsupported";
  try { return await Notification.requestPermission(); } catch { return "denied"; }
}

// title + optional body (body only passed when the user enabled previews)
export function showBrowserNotification(title, body, onClick) {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  try {
    const n = new Notification(title, { body: body || undefined, tag: "top-recruit-support", icon: "/favicon.svg" });
    if (onClick) n.onclick = () => { window.focus(); onClick(); n.close(); };
  } catch { /* ignore */ }
}

let _audio = null;
export function playNotifySound() {
  try {
    if (!_audio) {
      // short soft chime encoded inline (WebAudio fallback if data URI blocked)
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      _audio = new Ctx();
    }
    const ctx = _audio;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.connect(g); g.connect(ctx.destination);
    o.type = "sine"; o.frequency.value = 660;
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.12, ctx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.35);
    o.start(); o.stop(ctx.currentTime + 0.36);
  } catch { /* autoplay/permission constraints — ignore */ }
}
